import FilterListIcon from '@mui/icons-material/FilterList';
import { Button } from '@mui/material';
import { FilterPanelTrigger, GridToolbarFilterButton } from '@mui/x-data-grid-premium';
import { FC, memo, useState } from 'react';

export const FilterPanelToolbarFilterButton: FC = memo(() => {
  return (
    <FilterPanelTrigger
      render={(props) => (
        <Button
          {...props}
          size="small"
          startIcon={<FilterListIcon />}
          sx={{ minWidth: 'auto' }}
        >
          フィルター
        </Button>
      )}
    />
  );
});

FilterPanelToolbarFilterButton.displayName = 'GridToolbarFilterButton';


export const MyGridToolbarFilterButton: FC = memo(() => {
  // 画面を再描画しないとフィルターが開かないので、再描画を矯正するために値を更新する
  const [filterOpen, setFilterOpen] = useState(false);
  const toggleFilterOpen = () => {
    setFilterOpen(!filterOpen);
  };

  return <GridToolbarFilterButton nonce={undefined} onResize={undefined} onResizeCapture={undefined} onMouseOver={toggleFilterOpen} />;
});

export default MyGridToolbarFilterButton;
